module.exports = __webpack_public_path__ + "static/media/top_top.6e1b49e1.png";